const photos = [
  {
    src: "https://customer-assets.emergentagent.com/job_241680e8-f543-49d6-8cb5-996f4ac63eff/artifacts/4acluarf_IMG_0892.jpeg",
    label: "Front lawn · 9‑pass stripe",
    span: "lg:col-span-7 lg:row-span-2",
    aspect: "aspect-[4/5]",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_241680e8-f543-49d6-8cb5-996f4ac63eff/artifacts/vogg1wdp_IMG_0785.jpeg",
    label: "Backyard curve · summer",
    span: "lg:col-span-5",
    aspect: "aspect-[5/4]",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_241680e8-f543-49d6-8cb5-996f4ac63eff/artifacts/7cs5vn14_IMG_0791.jpeg",
    label: "Open acreage cut",
    span: "lg:col-span-3",
    aspect: "aspect-square",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_241680e8-f543-49d6-8cb5-996f4ac63eff/artifacts/noop7x1u_IMG_0036.jpeg",
    label: "Side yard · stripe + edge",
    span: "lg:col-span-2",
    aspect: "aspect-square",
  },
];

export default function Gallery() {
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="relative py-24 lg:py-32 bg-[#EAE8DF]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-6 mb-14 items-end">
          <div className="lg:col-span-7">
            <div className="font-mono-accent text-[11px] tracking-[0.25em] uppercase text-[#E64C23] mb-5">
              / The work
            </div>
            <h2 className="font-display uppercase text-4xl sm:text-5xl lg:text-6xl tracking-tight text-[#0B1C14] leading-[0.95]">
              Recent
              <br />
              <span className="italic">cuts.</span>
            </h2>
          </div>
          <p className="lg:col-span-5 text-[#4A5D53] text-base sm:text-lg leading-relaxed">
            Real lawns. Real customers. Shot the day we finished — no filters,
            no staging. Just the stripes.
          </p>
        </div>

        <div className="grid lg:grid-cols-12 gap-5">
          {/* First two: 7 / 5 split */}
          <figure
            data-testid="gallery-tile-1"
            className={`gallery-tile ${photos[0].span} ${photos[0].aspect} relative`}
          >
            <img src={photos[0].src} alt={photos[0].label} loading="lazy" />
            <figcaption className="absolute left-4 bottom-4 z-10 bg-[#0B1C14] text-white px-3 py-2 font-mono-accent text-[10px] tracking-[0.22em] uppercase">
              {photos[0].label}
            </figcaption>
          </figure>

          <div className="lg:col-span-5 grid grid-rows-2 gap-5">
            <figure
              data-testid="gallery-tile-2"
              className={`gallery-tile ${photos[1].aspect || ""} relative`}
            >
              <img src={photos[1].src} alt={photos[1].label} loading="lazy" />
              <figcaption className="absolute left-4 bottom-4 z-10 bg-[#E64C23] text-white px-3 py-2 font-mono-accent text-[10px] tracking-[0.22em] uppercase">
                {photos[1].label}
              </figcaption>
            </figure>

            <div className="grid grid-cols-2 gap-5">
              <figure
                data-testid="gallery-tile-3"
                className="gallery-tile aspect-square relative"
              >
                <img src={photos[2].src} alt={photos[2].label} loading="lazy" />
                <figcaption className="absolute left-3 bottom-3 z-10 bg-[#F4F3EF] text-[#0B1C14] px-2 py-1.5 font-mono-accent text-[9px] tracking-[0.22em] uppercase">
                  {photos[2].label}
                </figcaption>
              </figure>
              <figure
                data-testid="gallery-tile-4"
                className="gallery-tile aspect-square relative"
              >
                <img src={photos[3].src} alt={photos[3].label} loading="lazy" />
                <figcaption className="absolute left-3 bottom-3 z-10 bg-[#F4F3EF] text-[#0B1C14] px-2 py-1.5 font-mono-accent text-[9px] tracking-[0.22em] uppercase">
                  {photos[3].label}
                </figcaption>
              </figure>
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-wrap items-center justify-between gap-6 border-t border-[#0B1C14]/15 pt-7">
          <p className="font-display uppercase text-2xl sm:text-3xl tracking-tight text-[#0B1C14]">
            Want your lawn on this page?
          </p>
          <a
            data-testid="gallery-cta"
            href="#contact"
            className="btn-primary"
          >
            Book Your First Cut
          </a>
        </div>
      </div>
    </section>
  );
}
